import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  NbComponentStatus,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";

import { ProductService } from "../../services/product.service";

import { UserService } from "../../@core/services/user.service";
import { User } from "../../@core/data/users";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import * as _ from "lodash";
import { LocalDataSource } from "ng2-smart-table";
import { StbCustomRenderNumberComponent } from "../smart-table-customs/custom-render-number";
import { StbCustomRenderButtonComponent } from "../smart-table-customs/custom-render-button";
import { StbCustomRenderDateComponent } from "../smart-table-customs/custom-render-date";
import { StbCustomRenderIdComponent } from "../smart-table-customs/custom-render-id";
import { StbCustomRenderCheckboxComponent } from "../smart-table-customs/custom-render-checkbox";
import { Finance } from "../../models/finance.model";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DOUBLE_PATTERN } from "../../@auth/components/constants";
import { FinanceService } from "../../services/finance.service";
import { DialogFinanceComponent } from "../dialog-finance/dialog-finance.component";
import { Catalog } from "../../models/product.model";
import { Person } from "../../models/person.model";
import Shop from "../../models/shop.model";
import { environment } from "../../../environments/environment";

@Component({
  selector: "ngx-view-table-finances",
  styleUrls: ["./view-table-finances.component.scss"],
  templateUrl: "./view-table-finances.component.html",
})
export class ViewTableFinancesComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string = "";
  @Input() shop?: Shop;
  @Input() source: LocalDataSource = new LocalDataSource();
  @Input() groupFins?: Catalog[] = [];
  @Input() persons?: Person[] = [];
  @Output() onSelectedItem: EventEmitter<any> = new EventEmitter();
  @Output() onChangeData: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  isEditing = false;

  strSearch = "";
  uid = "anonymous";
  user: User;
  diaForm: FormGroup;
  @ViewChild("note") note: ElementRef;
  type = "receive"; //receive/issue
  amount = 0;
  issueDate: Date = new Date();

  //ng2-smart-table config
  settings = {};
  formatCurrency: string = environment.formatCurrency
    ? environment.formatCurrency
    : "#,###,###,###";

  constructor(
    private userService: UserService,
    private financeService: FinanceService,
    private dialogService: NbDialogService,
    private fb: FormBuilder,
    private toastrService: NbToastrService
  ) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.user = user;
          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }

          this.settings = {
            hideHeader: false,
            noDataMessage:
              user.language == "en" ? "Empty data" : "Không có dữ liệu",
            attr: {
              class: "table table-striped",
            },
            actions: {
              columnTitle: "",
              add: false,
              edit: false,
              delete: false,
            },
            columns: {
              issueDate: {
                title: user.language == "en" ? "Date" : "Ngày",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderDateComponent,
              },
              // id: {
              //   title: "Số phiếu",
              //   type: "custom",
              //   renderComponent: StbCustomRenderIdComponent,
              // },
              groupName: {
                title: user.language == "en" ? "Group" : "Nhóm",
                type: "string",
              },
              objectName: {
                title: user.language == "en" ? "Object" : "Đối tượng",
                type: "string",
              },
              personName: {
                title: user.language == "en" ? "Person" : "Người thu/chi",
                type: "string",
              },
              note: {
                title: user.language == "en" ? "Description" : "Diễn giải",
                type: "string",
              },
              receiveAmount: {
                title: user.language == "en" ? "Receive" : "Thu",
                width: "100px",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderNumberComponent,
              },
              issueAmount: {
                title: user.language == "en" ? "Issue" : "Chi",
                width: "100px",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderNumberComponent,
              },
              isBankTransfer: {
                title: user.language == "en" ? "Bank Transfer" : "Chuyển khoản",
                width: "100px",
                type: "custom",
                renderComponent: StbCustomRenderCheckboxComponent,
                filter: {
                  type: "checkbox",
                  config: {
                    true: "true",
                    false: "false",
                    resetText: "Xóa",
                  },
                },
              },
              // balance: {
              //   title: "Số dư",
              //   width: "100px",
              //   filter: false,
              //   type: "custom",
              //   renderComponent: StbCustomRenderNumberComponent,
              // },
            },
          };
        } else {
          this.uid = "anonymous";
        }
      });

    const noteValidators = [
      Validators.minLength(1),
      Validators.maxLength(500),
      Validators.required,
    ];
    const amountValidators = [
      Validators.pattern(DOUBLE_PATTERN),
      Validators.required,
    ];

    this.diaForm = this.fb.group({
      note: ["", noteValidators],
      amount: ["", amountValidators],
      type: [],
      issueDate: [],
    });

    this.diaForm.patchValue({
      note: "",
      amount: "",
      issueDate: new Date(),
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  //smart-table events
  selectedItem(event): void {
    const item = event.data;
    this.onSelectedItem.emit(item);

    if (item.customerId != "" || item.supplierId != "") {
      this.showToast("warning", "Xin vui lòng mở phiếu trong mục Công Nợ", "");
    } else {
      let itemMore = _.clone(item);
      this.dialogService
        .open(DialogFinanceComponent, {
          context: {
            mode: "edit",
            shopId: this.shopId,
            uid: this.uid,
            user: this.user,
            shop: this.shop,
            finance: itemMore,
            groupFins: this.groupFins,
            persons: this.persons,
          },
          closeOnBackdropClick: false,
        })
        .onClose.subscribe((value: any) => {
          if (value) {
            item.note = value.note;

            if (
              item.issueDate != value.issueDate ||
              item.receiveAmount != value.receiveAmount ||
              item.issueAmount != value.issueAmount
            ) {
              item.issueDate = value.issueDate;
              item.receiveAmount = value.receiveAmount;
              item.issueAmount = value.issueAmount;
              this.onChangeData.emit(true);
            }
          }
        });
    }
  }

  selectType(value) {
    this.type = value;
  }

  create() {
    this.strSearch = this.strSearch.trim();
    if (this.strSearch != "") {
      let prod = new Finance();
      prod.shopId = this.shopId;
      prod.issueDate = this.diaForm.value.issueDate;
      prod.note = this.diaForm.value.note;
      prod.isReceive = this.type === "receive" ? true : false;
      prod.receiveAmount =
        this.type === "receive"
          ? parseFloat(this.diaForm.value.amount.toString())
          : 0;
      prod.issueAmount =
        this.type !== "receive"
          ? parseFloat(this.diaForm.value.amount.toString())
          : 0;

      prod.personId = "";

      this.loading = true;
      this.submitted = true;

      this.financeService
        .create(prod)
        .then((data) => {
          this.diaForm.patchValue({
            note: "",
            amount: "",
          });

          this.strSearch = "";
          this.note.nativeElement.focus();

          this.loading = false;
          this.submitted = false;

          this.onChangeData.emit(true);
        })
        .catch((err) => {
          this.loading = false;
          this.submitted = false;
        });
    }
  }

  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
